import React, { useState } from "react";
import { Check } from "lucide-react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const list = JSON.parse(localStorage.getItem("edental_subs") || "[]");
      list.push({ email, ts: Date.now() });
      localStorage.setItem("edental_subs", JSON.stringify(list));
    } catch (_) {}
    setSubmitted(true);
    setEmail("");
    setTimeout(() => setSubmitted(false), 4000);
  };

  return (
    <section className="relative bg-[#FBF8F1] py-20">
      <div className="max-w-3xl mx-auto px-6">
        <div className="relative border border-[#B79A68]/40 px-8 py-14 md:p-16 text-center bg-[#ffffff]">
          {/* Inner gold frame */}
          <div className="absolute inset-3 border border-[#B79A68]/20 pointer-events-none" />
          <h2 className="font-cinzel text-3xl md:text-5xl gold-gradient-text tracking-[0.12em]">
            STAY IN TOUCH
          </h2>
          <p className="font-cinzel text-[11px] md:text-sm gold-gradient-text uppercase tracking-[0.3em] mt-4">
            Be The First To Hear About Our Exclusive Promotions!
          </p>
          <div className="flex items-center justify-center gap-3 my-7">
            <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#B79A68]" />
            <span className="w-1.5 h-1.5 rotate-45 bg-[#B79A68]" />
            <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#B79A68]" />
          </div>
          <form
            onSubmit={onSubmit}
            className="flex flex-col gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full px-4 py-3 bg-[#ffffff] border border-[#B79A68]/40 text-[#20322E] placeholder-[#B79A68]/50 focus:outline-none focus:border-[#B79A68] font-cinzel tracking-wider"
            />
            <button
              type="submit"
              className="bg-gradient-to-b from-[#B79A68] to-[#8D7448] hover:from-[#C8AE7F] hover:to-[#A18354] text-[#ffffff] py-3 uppercase text-xs tracking-[0.3em] font-semibold font-cinzel transition-all"
            >
              Sign Up
            </button>
          </form>
          {submitted && (
            <p className="mt-5 inline-flex items-center gap-2 text-[#5F4F30] text-sm">
              <Check size={16} /> Thank you — you&apos;re on the list.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
